<template lang="pug">
div(v-if="!cuenta")
  h1(mocuetitle) Los datos de la cuenta seleccionada son necesarios para conocer los datos del cliente.
div(v-else
    v-loading="loading"
    :loading-title="cuenta ? cuenta.cliente : $t('loyalty.search')"
    :loading-description="cuenta ? cuenta.desctidc + ': ' + cuenta.idclient : $t('loyalty.client')"
    loading-spinner="pulse"
    loading-background="rgba(255, 255, 255, 0.9)")
  ods-scrollbar(wrap-class="wrap-styles"
    tag="div"
    :native="true"
    style="height: calc(100vh - 75px); padding: 0 0 32px 0;")

    vista-cliente(v-if='showDetails && person.tipidcli && person.indexiste' :person='person')
    modifica-cliente(v-if='!showDetails && person.tipidcli && person.indexiste'
      :personData='person'
      @end-edit-client="reloadPerson")

    ods-row.buttons-row(type='flex' justify='end' v-if='showDetails')
      ods-button(type='primary' @click='showDetails = !showDetails' :loading='loading') {{ $t('commerceInfo.modifyData') }}

</template>
<script>
import { mapActions } from 'vuex'
import VistaCliente from '@/components/loyalty/Accounts/VistaCliente'
import ModificaCliente from '@/components/loyalty/Accounts/ModificaCliente'

export default {
  name: 'DetalleCliente',
  props: ['cuenta'],
  components: {
    'vista-cliente': VistaCliente,
    'modifica-cliente': ModificaCliente
  },
  data () {
    return {
      loading: true,
      showDetails: true,
      accountData: null,
      person: {
        apellid1: null,
        apellid2: null,
        codentid: null,
        codpostal: null,
        codprogr: null,
        codregion: null,
        desctidc: null,
        desclave1: null,
        desclave2: null,
        fecnac: null,
        idclient: null,
        indestciv: null,
        indexiste: null,
        nombre: null,
        poblacion: null,
        registro_Numero: null,
        sexo: null,
        tipidcli: null,
        tipmedio1: null,
        tipmedio2: null,
        type: null
      }
    }
  },
  created () {
    this.checkIDClient()
  },
  destroyed () {
    this.person = null
  },
  methods: {
    ...mapActions(['getIdDropdown', 'checkID']),
    async checkIDClient () {
      this.loading = true
      await this.getIdDropdown().then(resp => {
        for (const i in resp.registros) {
          if (resp.registros[i].desctidc && this.cuenta.desctidc && resp.registros[i].desctidc.trim() === this.cuenta.desctidc.trim()) {
            this.person.tipidcli = resp.registros[i].tipidcli
            this.person.desctidc = resp.registros[i].desctidc
          }
        }
      })

      const response = await this.checkID({
        idClient: this.cuenta.idclient,
        tipidcli: this.person.tipidcli
      })
      if (response.registros && response.registros.indexiste === 'S') {
        // console.log('Servicio de consulta cliente')
        // console.log(response)
        let nac = null
        if (response.registros.fecnac) {
          nac = new Date(response.registros.fecnac)
        }
        this.person = Object.assign({}, this.person, {
          idioma: this.$i18n.locale,
          nombre: response.registros.nombre ? response.registros.nombre : '',
          apellid1: response.registros.apellid1 ? response.registros.apellid1 : '',
          apellid2: response.registros.apellid2 ? response.registros.apellid2 : '',
          sexo: response.registros.sexo,
          codregion: response.registros.codregion,
          poblacion: response.registros.poblacion,
          codpostal: response.registros.codpostal,
          desclave1: response.registros.desclave1 ? response.registros.desclave1.replace(/\s+/g, ' ').trim() : '',
          desclave2: response.registros.desclave2 ? response.registros.desclave2.replace(/\s+/g, ' ').trim() : '',
          fecnac: {
            anno: nac ? nac.getFullYear() : 0,
            dia: nac ? nac.getDate() : 0,
            format: 'yyyy-MM-dd',
            mes: nac ? nac.getMonth() + 1 : 0,
            valueDate: nac ? response.registros.fecnac : ''
          },
          indestciv: response.registros.indestciv,
          codentid: response.registros.codentid,
          codprogr: response.registros.codprogr,
          idclient: response.registros.idclient,
          indexiste: response.registros.indexiste,
          registro_Numero: response.registros.registro_Numero,
          tipmedio1: response.registros.tipmedio1,
          tipmedio2: response.registros.tipmedio2,
          type: response.registros.type
        })
      } else {
        // console.log(response)
        return false
      }
      this.loading = false
    },
    reloadPerson () {
      this.showDetails = !this.showDetails
      this.checkIDClient()
    }
  }
}
</script>
<style lang="scss">
.mocuetitle {
  padding-top: 15px;
  font-size: 16px;
  color: #060E14;
  font-weight: 500;
  padding-bottom: 30px;
}
.mocueh2 {
  text-transform: uppercase;
  color: #72767b;
}
.mocuespan {
  font-weight: 500;
  font-size: 12px;
  color: #060E14;
  line-height: 56px;
}
.mocueherror {
  color: #DE2F2F;
}
.picto-datos {
  height: 68px;
  width: 114px;
}
.ods-dialog__body{
  img {
    width: 114px;
  }
}
</style>
